import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
import { _get_user_wallet_history } from "../common/axios_services";

const useWalletHistory = () => {
  const navigate = useNavigate();

  const [loyaltyHis, setLoyaltyHis] = useState([]);
  const [fetchingLoyalty, setFetchingLoyalty] = useState(true);
  const [pageLoy, setPageLoy] = useState(1);
  const [pageSizeLoy, setPageSizeLoy] = useState(10);
  const [totalLoy, setTotalLoy] = useState(0);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      description: message,
      placement: "bottomRight",
    });
  };

  const fetchUserWalletPayments = useCallback(async () => {
    try {
      const getPayment = await _get_user_wallet_history({
        page: pageLoy,
        limit: pageSizeLoy,
      });
      setLoyaltyHis(
        getPayment?.data?.data?.transactions.map((item) => ({
          ...item,
          total_amount: item.amount,
          timestamp: item.createdAt,
          payment_type: item.type,
          charges: item.charges || 0.0,
        }))
      );
      setTotalLoy(getPayment?.data?.data?.pagination?.total || getPayment?.data?.data?.total || 0);
      setFetchingLoyalty(false);
    } catch (err) {
      console.log({ err });
    }
  }, [pageLoy, pageSizeLoy]);

  return {
    loyaltyHis,
    fetchingLoyalty,
    pageLoy,
    pageSizeLoy,
    totalLoy,
    setPageLoy,
    setPageSizeLoy,
    fetchUserWalletPayments,
    openNotificationWithIcon,
  };
};

export default useWalletHistory;